<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>商城配置</span>

          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importUploadSuccess(res)}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:shopCfg:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:shopCfg:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData()"
              >导出</el-button>
            </el-col>

            <el-col :span="1.5">
              <el-upload
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importPrizeUploadSuccess(res)}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:shopCfg:import']" icon="el-icon-upload2" size="mini" type="primary">导入奖励</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:shopCfg:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportPrizeData()"
              >导出奖励</el-button>
            </el-col>
          </el-row>
        </div>

        <el-tabs tab-position="left" style="height: 200px;">
          <el-tab-pane label="用户管理">用户管理</el-tab-pane>
        </el-tabs>

        <el-form ref="formData" :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="商品ID">
              <el-input v-model.number="item.gid" style="width: 100px;" placeholder="游戏ID" />
            </el-form-item>
            <el-form-item label="商品类型">
              <el-input v-model.number="item.g_type" style="width: 100px;" placeholder="商品类型" />
            </el-form-item>
            <el-form-item label="等级">
              <el-input v-model.number="item.min_level" style="width: 80px;" placeholder="最小等级" />
            </el-form-item>
            <el-form-item label="-">
              <el-input v-model.number="item.max_level" style="width: 80px;" placeholder="最大等级" />
            </el-form-item>
            <el-form-item label="存在时间（小时）">
              <el-input v-model.number="item.life_time" style="width: 70px;" placeholder="存在时间" />
            </el-form-item>
            <el-form-item label="价格">
              <el-input v-model.trim="item.price" style="width: 80px;" placeholder="价格" />
            </el-form-item>
            <el-form-item label="谷歌SKU">
              <el-input v-model.number="item.sku" style="width: 80px;" placeholder="谷歌SKU" />
            </el-form-item>
            <el-form-item label="折扣">
              <el-input v-model.trim="item.discount" style="width: 80px;" placeholder="折扣" />
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model.number="item.status" style="width: 90px;" placeholder="请选择状态">
                <el-option
                  v-for="item in statusType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="其他配置">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="visibleArr[index].visible = true" />
              <el-dialog style="overflow-y: auto" :before-close="(d)=>{return handleClose(d, index)}" title="其他配置" width="800px" :visible="visibleArr[index].visible">
                <el-form>
                  <el-form-item label="配图文件路径">
                    <el-input
                      v-model="item.skin_dir"
                      type="textarea"
                      :rows="4"
                      :col="4"
                      placeholder="配图文件路径"
                    />
                  </el-form-item>
                  <el-form-item label="描述">
                    <el-input
                      v-model="item.desc"
                      type="textarea"
                      :rows="4"
                      :col="4"
                      placeholder="描述"
                    />
                  </el-form-item>
                  <el-row v-for="(r,i) in item.prize_json" :key="i">
                    <el-form-item label="奖品大类" style="margin-top: 10px;">
                      <el-select v-model.number="r.type" style="width: 130px;" placeholder="请选择" @change="(v)=>{return getRewardList(v, index, i)}">
                        <el-option
                          v-for="item in cateType"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="奖品ID" style="margin-top: 10px;">
                      <el-select v-model.number="r.id" style="width: 130px;" placeholder="请选择">
                        <el-option
                          v-for="item in options[index][i]"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="奖品数量" style="margin-top: 10px;">
                      <el-input v-model.number="r.num" style="width: 130px;" placeholder="奖品数量" />
                    </el-form-item>
                    <el-form-item style="margin-top: 10px;">
                      <el-button v-if="item.prize_json.length > 1" v-permisaction="['config:taskCfg:add']" type="danger" @click="removeReward(index, i)">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-form-item>
                    <el-button v-permisaction="['config:shopCfg:add']" type="primary" @click="addReward(index)">+</el-button>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="visibleArr[index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="visibleArr[index].visible = false">确 定</el-button>
                </div>
              </el-dialog>
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:shopCfg:del']" type="danger" size="mini" @click="del(index, item.id)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:shopCfg:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-if="formData.length > 0" v-permisaction="['config:shopCfg:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCateList, getRewardType } from '@/api/config/lucky-draw'
import {
  deleteShopCfg,
  exportShopCfg,
  exportShopPrizeCfg,
  getShopCfgList, getShopType,
  importShopCfg,
  importShopPrizeCfg,
  updateShopCfg
} from '@/api/config/shop-cfg'
import { getToken } from '@/utils/auth'
export default {
  name: 'Shop',
  data() {
    return {
      shopType: [],
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      statusType: [{
        value: 1,
        label: '开启'
      }, {
        value: 0,
        label: '关闭'
      }],
      options: [[]],
      visibleArr: [{ visible: false }],
      formData: [
        {
          'id': 0,
          'gid': 0,
          'g_type': 0,
          'desc': '',
          'min_level': 0,
          'max_level': 0,
          'life_time': 0,
          'price': 0,
          'sku': 0,
          'discount': 0,
          'skin_dir': '',
          'status': 0,
          'ss_group': '',
          'prize_json': [
            {
              type: 1,
              id: 201,
              num: 1
            }
          ]
        }
      ],
      cateType: [],
      selectType: [
        {
          'id': 1,
          'title': '金币'
        },
        {
          'id': 2,
          'title': '体力'
        },
        {
          'id': 3,
          'title': '卡片'
        },
        {
          'id': 4,
          'title': '星星'
        }
      ]
    }
  },
  created() {
    this.getTables()
    this.getCateType()
    this.getShopTypes()
  },
  methods: {
    getShopTypes() {
      getShopType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            console.log(res.data[i])
          }
          this.cateType = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(d, index) {
      this.visibleArr[index].visible = false
    },
    onSubmit() {
      const data = []

      for (const k in this.formData) {
        const item = this.formData[k]
        if (item.min_level > item.max_level) {
          this.msgError('最低等级不能大于最高等级')
          return
        }

        if (item.price < 0) {
          this.msgError('金额不能小于0')
          return
        }

        if (item.discount < 0) {
          this.msgError('优惠金额不能小于0')
          return
        }
        item.price = parseFloat(item.price)
        item.discount = parseFloat(item.discount)
        data.push(item)
      }
      const postdata = JSON.stringify(data)
      updateShopCfg({ data: postdata }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getShopCfgList().then(res => {
        if (res.code === 200) {
          this.formData = res.data
          res.data.forEach((item, index) => {
            this.visibleArr.push({
              visible: false
            })
            // this.options[index] = []
            this.$set(this.options, index, [])
            if (item.prize_json) {
              item.prize_json.forEach((item, i) => {
                this.getRewardList(item.type, index, i)
              })
            } else {
              item.prize_json = []
            }
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addReward(index) {
      console.log('index', this.formData[index])
      this.formData[index].prize_json.push({
        type: 1,
        id: 201,
        num: 1
      })
      const zIndex = this.formData[index].prize_json.length - 1
      console.log('zindex', zIndex)
      this.getRewardList(1, index, zIndex)
    },
    getRewardList(v, index, zIndex) {
      getRewardType({ id: v }).then(res => {
        if (res.code === 200) {
          console.log('add Option', index, zIndex)
          // this.options[index][zIndex] = res.data
          this.$set(this.options[index], zIndex, res.data)

          console.log(this.options[index])
        } else {
          console.log(res.msg)
        }
      })
    },
    removeReward(index, zIndex) {
      this.formData[index].prize_json = this.formData[index].prize_json.filter((item, i) => {
        return i !== zIndex
      })
    },
    getCateType() {
      getCateList().then(res => {
        if (res.code === 200) {
          this.cateType = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'id': 0,
        'gid': 0,
        'g_type': 0,
        'desc': '',
        'min_level': 0,
        'max_level': 0,
        'life_time': 0,
        'price': 0,
        'sku': 0,
        'discount': 0,
        'skin_dir': '',
        'status': 0,
        'ss_group': '',
        'prize_json': [
          {
            type: 1,
            id: 201,
            num: 1
          }
        ],
        'other_json': ''
      })
      this.visibleArr.push({ visible: false })
      const index = this.formData.length - 1
      // this.options[index] = []
      this.$set(this.options, index, [])

      // this.$set(this.options[index], zIndex, res.data)
      this.getRewardList(1, index, 0)
    },
    del(key, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteShopCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })
      }
      this.formData = this.formData.filter((item, index) => {
        return index !== key
      })
    },
    exportData() {
      exportShopCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportPrizeData() {
      exportShopPrizeCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response) {
      importShopCfg({ data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importPrizeUploadSuccess(response) {
      importShopPrizeCfg({ data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
